import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Loader, Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import SoftSignalButton from 'components/DataroomNodeViewModal/components/SoftSignalButton';
import { SOFT_SIGNALS, SoftSignal } from 'models/Lead';

import './DataRoomConfirmInterestModal.styles.scss';

type DataRoomConfirmInterestModalProps = {
  className?: string;
  isLoading?: boolean;
  onConfirmInterest: (softSignal: SoftSignal) => void;
} & ModalProps;

const DataRoomConfirmInterestModal: React.ForwardRefRenderFunction<
  ModalRef,
  DataRoomConfirmInterestModalProps
> = (props, ref) => {
  const { className, isLoading, onConfirmInterest, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('data-room-confirm-interest-modal', className);

  const { t } = useTranslation();

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('areYouStillInterested')}
      {...rest}
    >
      <div className="data-room-confirm-interest-modal__content">
        <p>{t('youveReviewedEverything')}</p>

        {isLoading && <Loader />}

        <div className="actions">
          <SoftSignalButton
            disabled={isLoading}
            softSignal={SOFT_SIGNALS.DISLIKE}
            onClick={() => onConfirmInterest(SOFT_SIGNALS.DISLIKE)}
          >
            {t('notNow')}
          </SoftSignalButton>
          <SoftSignalButton
            disabled={isLoading}
            softSignal={SOFT_SIGNALS.UNSURE}
            onClick={() => onConfirmInterest(SOFT_SIGNALS.UNSURE)}
          >
            {t('notSure')}
          </SoftSignalButton>
          <SoftSignalButton
            disabled={isLoading}
            softSignal={SOFT_SIGNALS.LIKE}
            onClick={() => onConfirmInterest(SOFT_SIGNALS.LIKE)}
          >
            {t('yesImInterested')}
          </SoftSignalButton>
        </div>
      </div>
    </Modal>
  );
};

export default forwardRef(DataRoomConfirmInterestModal);
